import { useQuery } from '@tanstack/react-query';
import type { PublicCompanyProfile, PublicStats } from '@biyolink/shared';
import { getData } from './client';

export const statsKeys = {
  publicStats: ['stats', 'public'] as const,
};

/** Ana sayfadaki sayaçlar (docs/05 §3.1). */
export function usePublicStats() {
  return useQuery({
    queryKey: statsKeys.publicStats,
    queryFn: () => getData<PublicStats>('/stats/public'),
    staleTime: 5 * 60 * 1000,
  });
}

export const publicCompanyKeys = {
  profile: (slug: string) => ['company', 'profile', slug] as const,
};

/** Herkese açık firma profili + aktif ilanları (docs/05 §3.4). */
export function usePublicCompanyProfile(slug: string | undefined) {
  return useQuery({
    queryKey: publicCompanyKeys.profile(slug ?? ''),
    queryFn: () => getData<PublicCompanyProfile>(`/companies/${slug}`),
    enabled: Boolean(slug),
  });
}
